import React from "react";
import classNames from "classnames";
import { Semibold } from "capitalrx-components-2.0/lib/typography";

interface Props {
  pageIndex: number;
  isSelectedPage: boolean;
  handleSelectPage: (index: number) => void;
}

const PaginationItem: React.FC<Props> = (props: Props): JSX.Element => {
  const { pageIndex, isSelectedPage = false, handleSelectPage } = props;

  const itemClassList = classNames("caprx-pagination-item", `caprx-pagination-item-num-${pageIndex + 1}`, {
    "caprx-pagination-item-selected-page": isSelectedPage,
  });

  return (
    <div className={itemClassList}>
      <a className="caprx-pagination-link" onClick={(): void => handleSelectPage(pageIndex)} tabIndex={0}>
        <Semibold>
          {pageIndex + 1}
        </Semibold>
      </a>
    </div>
  );
};

export default PaginationItem;
